import { useEffect, useRef, useState, type ReactNode } from "react";
import styles from "./styles.module.scss";
import Line from "../../../assets/line.png";
import { Footer } from "components/frontComponents/footer/Footer";
import classnames from "classnames";
import Hamburger from "hamburger-react";

export interface NotScrollJournalPageProps {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

const navItems = [
  { name: "Главная", link: "/" },
  { name: "О нас", link: "/#about" },
  { name: "Компоненты", link: "/#components" },
  { name: "Контакты", link: "/#contacts" },
];
export const NotScrollJournalPage: React.FC<NotScrollJournalPageProps> = ({
  leftContent,
  rightContent,
}) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  const mobileMenuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        isOpen
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setOpen]);
  return (
    <div className={styles.journalPage}>
      <div className={styles.left}>
        <div className={styles.header}>
          <div className={styles.desktopMenu}>
            <div className={styles.logo}>
              <div className={styles.logotitle}>КиберФит</div>
              <div className={styles.logotext}>
                EST. 2025 | революция на стыке геймификации и фитнеса
              </div>
            </div>
            <div className={styles.headerline} />
            <nav className={styles.buttonsholder}>
              {navItems.map((item) => (
                <a href={item.link} className={styles.button}>
                  {item.name}
                </a>
              ))}
            </nav>
            <div className={styles.headerline} />
          </div>
          <div className={styles.mobileMenuContainer}>
            <div className={styles.logoholder}>
              <div className={styles.logo}>
                <div className={styles.logotitle}>КиберФит</div>
                <div className={styles.logotext}>
                  EST. 2025 | революция на стыке геймификации и фитнеса
                </div>
              </div>{" "}
              <div className={styles.hamburgerholder}>
                <Hamburger
                  toggled={isOpen}
                  toggle={setOpen}
                  color="black"
                  size={30}
                />
              </div>
            </div>
            <div
              className={classnames(
                styles.mobileMenu,
                isOpen ? styles.mobileMenuOpen : styles.mobileMenuClosed
              )}
              ref={mobileMenuRef}
            >
              <nav className={styles.mobileButtonsholder}>
                {navItems.map((item) => (
                  <a href={item.link} className={styles.mobileButton}>
                    {item.name}
                  </a>
                ))}
              </nav>
            </div>
          </div>{" "}
        </div>
        {leftContent}
      </div>
      <img src={Line} className={styles.line} alt="verticalline" />
      <div className={styles.right}>
        {rightContent}
        <Footer />
      </div>
    </div>
  );
};
